export default __webpack_public_path__ + "static/media/single-window-remediation.7b0a39a3.svg";